// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._154iidpf{top:0}
._18m915vq{overflow-y:hidden}
._1ltvidpf{left:0}
._1reo15vq{overflow-x:hidden}
._1xi2idpf{right:0}
._94n5idpf{bottom:0}
._a52dkb7n:hover~* .actions-button-group{opacity:1}
._azhw1osq{text-indent:100%}
._o5721q9c{white-space:nowrap}
a._hboxstnw.layered-link{position:absolute}
a._obkmidpf.layered-link{z-index:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/FlexibleCard/components/container/layered-link/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,KAAK;AAChB,WAAW,iBAAiB;AAC5B,WAAW,MAAM;AACjB,WAAW,iBAAiB;AAC5B,WAAW,OAAO;AAClB,WAAW,QAAQ;AACnB,yCAAyC,SAAS;AAClD,WAAW,gBAAgB;AAC3B,WAAW,kBAAkB;AAC7B,yBAAyB,iBAAiB;AAC1C,yBAAyB,SAAS","sourcesContent":["._154iidpf{top:0}\n._18m915vq{overflow-y:hidden}\n._1ltvidpf{left:0}\n._1reo15vq{overflow-x:hidden}\n._1xi2idpf{right:0}\n._94n5idpf{bottom:0}\n._a52dkb7n:hover~* .actions-button-group{opacity:1}\n._azhw1osq{text-indent:100%}\n._o5721q9c{white-space:nowrap}\na._hboxstnw.layered-link{position:absolute}\na._obkmidpf.layered-link{z-index:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
